<template>
  <div id="tablePage">
    <!-- 交收结果查询(配对查询) -->
    <div class="orderTable">
      <el-table
        ref="tableData"
        :data="tableData"
        :height="tableHeight"
        v-loading="loading"
      >
        <template slot="empty" v-if="!loading">
          <div v-if="isNetWrong" class="no-datas">
            <div class="no-data-img">
              <img src="../../../assets/images/no_data.png" alt="" style="width: 100%;">
            </div>
            <div class="no-data" style="margin-top: -15px !important; text-align: center;" @click="showData">加载失败,点击重试</div>
          </div>
          <div v-else class="no-datas">
            <div class="no-data-img">
              <img src="../../../assets/images/no_data.png" alt="" style="width: 100%;">
            </div>
            <div class="no-data">暂无数据</div>
          </div>
        </template>
        <el-table-column type="index" label="序号" width="80">
        </el-table-column>
        <el-table-column
          prop="commodityName"
          label="交易品种"
        >
        </el-table-column>
        <el-table-column
          prop="ChBsFlag"
          label="方向"
        >
        </el-table-column>
        <el-table-column
          prop="buyUserName"
          label="买方名称"
        >
        </el-table-column>
        <el-table-column
          prop="sellUserName"
          label="卖方名称"
        >
        </el-table-column>
        <!-- <el-table-column
          prop="storageName"
          label="仓库"
          min-width="150"
        >
        </el-table-column> -->
        <el-table-column
          prop="quantity"
          label="数量"
          min-width="90"
        >
        </el-table-column>
        <el-table-column
          prop="tradePrice"
          label="交收价格"
        >
        </el-table-column>
        <!-- <el-table-column
          prop="weight"
          label="总重量"
          min-width="90"
        >
        </el-table-column> -->
        <el-table-column
          prop="createTime"
          label="交收时间"
          width="90"
        >
          <template slot-scope="scope">
            <span> {{ scope.row.createTime | dateFormateSfDay }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="status"
          label="状态"
        >
          <template slot-scope="scope">
            <!-- 成功,失败,处理中 -->
            <span>已完成</span>
          </template>
        </el-table-column>
      </el-table>
      <el-row v-if="pageData.total">
        <el-col :span="24" class="paginateWrap">
          <el-pagination
            class="paginationPage"
            popper-class="_popStyle"
            :current-page="pageData.currentPage"
            :page-sizes="pageData.pageSizes"
            :page-size="pageData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageData.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
/*global http*/
import {
  mapGetters
} from 'vuex'
import protocolSS from '../protocol/protocolSS'
export default {
  data() {
    return {
      tableHeight: 0,
      loading: false,
      tableData: [],
      pageData: {
        total: null,
        pageSizes: [10, 20, 30, 40],
        pageSize: 20,
        currentPage: 1
      },
      isNetWrong: false
    }
  },
  computed: {
    ...mapGetters(['sessionInfoGetter'])
  },
  created() {
    window.onresize = () => {
      this.$nextTick(() => {
        this.tableHeight = util.autoHeightTable(this.$refs.tableData.$el.offsetTop + 32)
      })
    }
  },
  updated() {
    this.$nextTick(() => {
      this.tableHeight = util.autoHeightTable(this.$refs.tableData.$el.offsetTop + 32)
      this.$refs['tableData'].doLayout()
    })
  },
  mounted() {
    this.showData()
  },
  methods: {
    // 分页
    handleSizeChange(val) {
      this.pageData.pageSize = val
      this.showData()
    },
    handleCurrentChange(val) {
      this.pageData.currentPage = val
      this.showData()
    },
    // 订单展示
    showData() {
      var date = new Date()
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var day = date.getDate()
      const startTime = `${year}/${month}/${day} 00:00:00`
      const endTime = `${year}/${month}/${day} 23:59:59`
      protocolSS.param_getPair.param.startTime = new Date(startTime).getTime()
      protocolSS.param_getPair.param.endTime = new Date(endTime).getTime()
      protocolSS.param_getPair.param.page = this.pageData.currentPage - 1
      protocolSS.param_getPair.param.size = '' + this.pageData.pageSize
      protocolSS.param_getPair.param.sort = [{
        direction: 'DESC',
        property: 'deliveryId'
      }]
      this.loading = true
      http.postFront1(protocolSS.param_getPair).then(response => {
        if (response.data) {
          if (response.data && response.data.code == '0') {
            this.pageData.total = response.data.value.totalElements
            const arr = response.data.value.content
            const that = this
            this.each(arr, function(arrIndex) {
              arrIndex.ChBsFlag = arrIndex.sellFirmId == that.sessionInfoGetter.firmId ? '卖' : '买'
              // arrIndex.ChBsFlag = arrIndex.bsFlag === 'B' ? '买' : '卖'
            })
            this.tableData = arr
          }
        }
        this.loading = false
      })
    }

  }

}
</script>
